<template>
    <footer>
        <section class="footer-section" v-if="isAuthenticated">
            <div class="container">
                <div class="column-wrapper">
                    <div class="column nav">
                        <h3 class="column-title">More info</h3>
                        <nav>
                            <ul>
                                <li><router-link to="/privacy-policy">Privacy policy</router-link></li>
                                <li><router-link to="/terms-and-conditions">Terms and conditions</router-link></li>
                            </ul>
                        </nav>
                    </div>
                    <div class="column nav">
                        <h3 class="column-title">Congress secretariat</h3>
                        <ul>
                            <li>T. <a href="tel:+310736901415">+31(0)73 6901415</a></li>
                            <li>E. <a href="mailto:anr2023@congresscare.com">anr2023@congresscare.com</a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </section>
        <section class="copyright">
            <div class="copy-container">
                <div class="footer-logos">
                    <a href="https://faber-av.com/nl/" target="_blank" class="logo-wrapper">
                        <img class="logo" alt="Logo" src="@/assets/svgs/faber-logo-white.svg" />
                    </a>
                    <a href="https://streampac.io" target="_blank" class="logo-wrapper">
                        <img class="logo" alt="Logo" src="@/assets/svgs/streampac-logo-white.svg" />
                    </a>
                </div>

                <div class="copy-txt">
                    &copy; ANR2023
                </div>
            </div>
        </section>
    </footer>
</template>

<script>
// @import component
//import ChangeUsernamePopup from '@/components/ChangeUsernamePopup';
export default {
    inject: ["isAuthenticated"],
    components: {
        //ChangeUsernamePopup
    },
};
</script>

<style lang="scss" scoped>
// @import styles
@import "./index.scss";
</style>
